import React from 'react'
import styled from 'styled-components'
import EmptyBoxSvg from './EmptyBoxSvg'

export default function NoContent({ children, padding, gap, alignSelf }) {
  return (
    <NoContentWrapper padding={padding} gap={gap} alignSelf={alignSelf}>
      {children}
    </NoContentWrapper>
  )
}

NoContent.Icon = () => {
  return <EmptyBoxSvg />
}

NoContent.Description = ({ children }) => {
  return <span>{children}</span>
}

const NoContentWrapper = styled.div(
  ({ padding = '48px 24px', gap = '32px', alignSelf = 'stretch' }) => `
  display: flex;
  padding: ${padding};
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: ${gap};
  align-self: ${alignSelf};
  width: 100%;
  height: 100%;
  svg {
    width: 141.956px;
    height: 117.339px;
    flex-shrink: 0;
  }

  span {
    color: #767676;
    text-align: center;
    font-size: 24px;
    font-style: normal;
    font-weight: 600;
    line-height: normal;
  }
`
)
